<app-card-table
  tableKey="userWorkplaces"
  [tableTitle]="prefix + 'labelMulti'"
  [gridData]="$any(store.data.userWorkplaces$ | async)"
  [columns]="columns"
  [translatePrefix]="prefix"
  [hideCheckboxes]="true"
  [additionalFilter]="additionalFilter"
  [refreshCallback]="store.api.getUserWorkplaces"
  (createCallback)="openDialog()"
  (detailCallback)="openDialog($event)"
  (deleteCallbackWithEvent)="delete($event)"
  [showCreate]="canEdit"
  [showDetail]="canEdit"
  [showDelete]="canEdit"
  >
  <ng-template pTemplate="opened" let-item="item">
    @if ({ isOpen: item.hours | userWorkplaceIsOpen:item.validFrom }; as data) {
      <app-green-or-red-dot [value]="data.isOpen"></app-green-or-red-dot>
    }
  </ng-template>
</app-card-table>
